export default {
    PtFieldManagerPanel: {
        avaliableFields: 'Available Fields',
        displayFields: 'Displayed Fields',
        patentFields: 'Patent fields',
        customFields: 'Custom fields',
        searchPlaceholder: 'Search fields',
        noData: 'You do not have any custom fields',
        searchNoData: 'No results found',
        spaceScopeFieldTip: 'Index value is limited to current workspace',
    },
};
